var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cover-editor',{on:{"refresh":_vm.refresh}}),_c('photo-editor',{staticStyle:{"margin-top":"-50px"},on:{"refresh":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }